/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 19,
        height: 16,
        viewBox: "0 0 19 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M5.52 4.6c.1-.09.19-.38.38-.38.86-.19 1.73-.28 2.69-.38.1 0 .38.2.48.29.29.67.48 1.44.67 2.2.38-.47.77-1.05 1.25-1.43a4 4 0 0 1 1.44-.96c.48-.2 1.15 0 1.34.48s.2.96-.1 1.34c-.47.38-.95.29-1.43.1-.68-.39-.87-.3-1.35.28-.77.77-1.15 1.64-.67 2.79.29.67.29 1.34.48 2.01q.3 1.01 1.15.3c.29-.3.48-.58.87-.97 0 .29.1.58.1.67-.58.58-1.06 1.25-1.74 1.73-.96.67-1.82.39-2.3-.67a11 11 0 0 1-.67-1.92c-.39.67-.87 1.34-1.25 1.92s-.96.96-1.73.96c-.48 0-.86-.29-1.15-.77-.2-.29-.1-.77.2-1.15.38-.29.76-.29 1.24-.1 1.06.39 1.06.3 1.73-.57s.86-1.73.48-2.79c-.2-.48-.2-.96-.29-1.34-.2-1.25-.38-1.44-1.82-1.63",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M4.13 2.18a7.97 7.97 0 0 0-.93 11.38",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M14.2 13.3a7.97 7.97 0 0 0 .92-11.38",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
